import React, { FC } from 'react';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { GetProtocolQuotaResponse } from '@app/hooks/router-intent/types';
import { TransactionReceipt } from 'node_modules/thirdweb/dist/types/transaction/types';
import { VStack, Text, HStack, Badge } from '@chakra-ui/react';
import { InfoRow } from '@app/components/TransactionsHistory/components/InfoRow';
import { useRouterIntentState } from '@app/state/routerIntentStore';
import { NetworkIcon } from '@app/components/NetworkIcon';
import { Base, Mode } from '@thirdweb-dev/chains';

interface Props {
  details: GetProtocolQuotaResponse | null | undefined;
  isLoading: boolean;
  isAvailable: boolean;
  txResult: TransactionReceipt | undefined;
}

export const DepositLiquidityProgress: FC<Props> = ({ details, txResult }) => {
  const { sourceNetwork, targetChainId } = useRouterIntentState();
  const targetNetwork = targetChainId === Mode.chainId ? Mode : Base;

  if (!details || !txResult) {
    return null;
  }

  return (
    <>
      <AddLiquiditySectionTitle
        label="Track your transaction"
        isCompleted={true}
      />
      {details.PayLoad?.quote.map((item, i) => {
        return (
          <VStack
            key={i}
            width="100%"
            gap={2}
            mt={4}
            border="1px solid"
            borderColor="neutral.700"
            p="12px"
            borderRadius="12px"
            alignItems="flex-start"
          >
            <Text fontSize="16px" fontWeight={500} mb={2}>
              {item.adapterId}
            </Text>
            <InfoRow
              label="Status"
              value={
                <Badge
                  sx={{
                    backgroundColor: 'neutral.800',
                    p: '4px 12px',
                    borderRadius: '12px',
                    color: txResult ? 'success' : 'neutral.200',
                    fontSize: '14px'
                  }}
                >
                  {txResult ? 'Success' : 'Pending'}
                </Badge>
              }
            />
            {'bridgeFee' in item ? (
              <>
                <InfoRow
                  label="Source"
                  value={
                    <HStack>
                      <NetworkIcon
                        name={sourceNetwork?.name}
                        iconUrl={sourceNetwork?.icon?.url.replace(
                          'ipfs://',
                          'https://ipfs.io/ipfs/'
                        )}
                      />
                      <Text>{sourceNetwork?.name}</Text>
                    </HStack>
                  }
                />
                <InfoRow
                  label="Target"
                  value={
                    <HStack>
                      <NetworkIcon
                        name={targetNetwork.name}
                        iconUrl={targetNetwork?.icon?.url.replace(
                          'ipfs://',
                          'https://ipfs.io/ipfs/'
                        )}
                      />
                      <Text>{targetNetwork?.name}</Text>
                    </HStack>
                  }
                />
              </>
            ) : (
              <>
                <InfoRow
                  label="Chain"
                  value={
                    <HStack>
                      <NetworkIcon
                        name={targetNetwork.name}
                        iconUrl={targetNetwork?.icon?.url.replace(
                          'ipfs://',
                          'https://ipfs.io/ipfs/'
                        )}
                      />
                      <Text>{targetNetwork?.name}</Text>
                    </HStack>
                  }
                />
              </>
            )}
          </VStack>
        );
      })}
    </>
  );
};
